import React from "react";

import { Icon, Tooltip, Typography } from "components";

export interface SectionHeadingProps {
  title: string;
  /** The one supporting line under the title. */
  supporting?: string;
  /** Info affordance beside the title; without `onInfo` it is a tooltip only. */
  infoLabel?: string;
  onInfo?: () => void;
  /** Right-aligned control — a picker, a button, a view toggle. */
  control?: React.ReactNode;
  dataTestId?: string;
}

/** The one heading treatment every section uses, so titles, supporting lines and controls line up. */
export const SectionHeading = ({ title, supporting, infoLabel, onInfo, control, dataTestId = "section-heading" }: SectionHeadingProps) => (
  <div className="section-heading" data-testid={dataTestId}>
    <div className="section-heading-titles">
      <div className="section-heading-title-row">
        <Typography variant="h4" className="section-heading-title" key={title}>
          {title}
        </Typography>
        {infoLabel ? (
          <Tooltip title={infoLabel} placement="top">
            {onInfo ? (
              <button type="button" className="section-heading-info" onClick={onInfo} aria-label={infoLabel} data-testid={`${dataTestId}-info`}>
                <Icon iconName="tabler/info-circle" size="s" aria-hidden />
              </button>
            ) : (
              <span className="section-heading-info" tabIndex={0} aria-label={infoLabel} data-testid={`${dataTestId}-info`}>
                <Icon iconName="tabler/info-circle" size="s" aria-hidden />
              </span>
            )}
          </Tooltip>
        ) : null}
      </div>
      {supporting ? (
        <Typography variant="paragraph-s" className="section-heading-supporting" data-testid={`${dataTestId}-supporting`}>
          {supporting}
        </Typography>
      ) : null}
    </div>
    {control ? <div className="section-heading-control">{control}</div> : null}
  </div>
);

export default SectionHeading;
